import { useNavigate } from "react-router-dom";
import { GoAlertFill, GoCheckCircleFill } from "react-icons/go";
import PageShell from "../PageShell/PageShell";
import { formatCustomerName } from "../../utils/appointment";
import styles from "./PaymentResult.module.css";

function PaymentResult({
    tone,
    title,
    message,
    appointment = null,
    errorMessage = "",
    showRetry = false,
    customerInfo = null,
    onNotifyCustomer = null,
    notifyMessage = "",
}) {
    const navigate = useNavigate();
    const isSuccess = tone === "success";
    const resolvedCustomerInfo = customerInfo ?? appointment?.customer_info ?? {
        first_name: appointment?.customer_first_name,
        last_name: appointment?.customer_last_name,
        email: appointment?.customer_email ?? appointment?.email,
        phone: appointment?.customer_phone ?? appointment?.phone,
    };
    const customerName = formatCustomerName(resolvedCustomerInfo);
    const customerEmail = resolvedCustomerInfo?.email || "—";
    const customerPhone = resolvedCustomerInfo?.phone || "—";

    return (
        <PageShell>
            <div className={styles.container}>
                <section className={styles.card}>
                    <span
                        className={`${styles.icon} ${isSuccess ? styles.iconSuccess : styles.iconFailure}`}
                        aria-hidden="true"
                    >
                        {isSuccess ? <GoCheckCircleFill /> : <GoAlertFill />}
                    </span>

                    <h1 className={styles.title}>{title}</h1>
                    <p className={styles.message}>{message}</p>

                    {errorMessage && <p className={styles.errorBanner}>{errorMessage}</p>}

                    {(appointment || resolvedCustomerInfo) && (
                        <dl className={styles.summary}>
                            <dt className={styles.summaryLabel}>Customer</dt>
                            <dd className={styles.summaryValue}>{customerName}</dd>

                            <dt className={styles.summaryLabel}>Phone</dt>
                            <dd className={styles.summaryValue}>{customerPhone}</dd>

                            <dt className={styles.summaryLabel}>Email</dt>
                            <dd className={styles.summaryValue}>{customerEmail}</dd>
                        </dl>
                    )}

                    {onNotifyCustomer && (
                        <div className={styles.notifyBlock}>
                            <button
                                type="button"
                                className={styles.notifyButton}
                                onClick={onNotifyCustomer}
                            >
                                Notify Customer
                            </button>
                            {notifyMessage && (
                                <p className={styles.notifyMessage}>{notifyMessage}</p>
                            )}
                        </div>
                    )}

                    <div className={styles.actions}>
                        {showRetry && (
                            <button
                                type="button"
                                className={styles.secondaryButton}
                                onClick={() => navigate(-1)}
                            >
                                Back to appointment
                            </button>
                        )}
                        <button
                            type="button"
                            className={styles.primaryButton}
                            onClick={() => navigate("/")}
                        >
                            Go to Home
                        </button>
                    </div>
                </section>
            </div>
        </PageShell>
    );
}

export default PaymentResult;
